module.exports = __webpack_public_path__ + "static/media/bio.8a3a8346.md";